export default __webpack_public_path__ + "static/media/signingContract.02923ae3.svg";